module.exports = __webpack_public_path__ + "be3856e00cc15a4c6cd56863bc06e28e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/knockout-htg30-juniorwelterwt.otf
// module id = 32
// module chunks = 0